import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/ImageComponent.css';
import './firebase'; // Import Firebase configuration

// Determine which entry point to use based on the environment variable
const isTestMode = process.env.REACT_APP_TEST_MODE === 'true';

// Dynamically import the appropriate entry point
if (isTestMode) {
  // In test mode, import the test entry point
  import('./test-index');
} else {
  // In normal mode, import the main app
  import('./App').then((AppModule) => {
    const App = AppModule.default;
    
    // Unregister all service workers on startup to prevent potential issues
    const unregisterServiceWorkers = async () => {
      if ('serviceWorker' in navigator) {
        try {
          const registrations = await navigator.serviceWorker.getRegistrations();
          for (const registration of registrations) {
            await registration.unregister();
            console.log('SW unregistered successfully');
          }
          // Clear any service worker caches
          if ('caches' in window) {
            const cacheNames = await caches.keys();
            await Promise.all(
              cacheNames.map(cacheName => caches.delete(cacheName))
            );
            console.log('All caches cleared');
          }
        } catch (error) {
          console.error('Error unregistering service workers:', error);
        }
      }
    };

    // First unregister service workers, then mount the app
    unregisterServiceWorkers().then(() => {
      const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
      );
      
      root.render(
        // Temporarily removing StrictMode which causes double rendering
        // <React.StrictMode>
          <App />
        // </React.StrictMode>
      );
    });
    
    // Temporarily disable service worker registration to diagnose the issue
    // We'll enable this again once the page reload issue is resolved
    /*
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        setTimeout(() => {
          navigator.serviceWorker.register('/service-worker.js')
            .then(registration => {
              console.log('SW registered: ', registration);
            })
            .catch(registrationError => {
              console.log('SW registration failed: ', registrationError);
            });
        }, 3000); // Delay registration to ensure app is fully loaded
      });
    }
    */
  });
}
